export const SET_GLOBAL_LOADER = 'SET_GLOBAL_LOADER';
export const SET_PAYMENT_INVOICE_DATA = 'SET_PAYMENT_INVOICE_DATA';
export const SET_CHECKOUT_OPTIONS = 'SET_CHECKOUT_OPTIONS';
export const SET_UI_THEME = 'SET_UI_THEME';

export const SET_SERVICES = 'SET_SERVICES';
export const SET_METHODS = 'SET_METHODS';

export const SET_SELECTED_SERVICE = 'SET_SELECTED_SERVICE';
export const SET_SELECTED_METHODS = 'SET_SELECTED_METHODS';

export const SET_SELECTED_METHOD = 'SET_SELECTED_METHOD';
export const SET_CURRENT_STEP = 'SET_CURRENT_STEP';

export const SET_CATEGORIES_LIST = 'SET_CATEGORIES_LIST';
export const SET_SELECTED_CATEGORY = 'SET_SELECTED_CATEGORY';

export const SET_PUBLIC_API_KEY = 'SET_PUBLIC_API_KEY';
export const SET_GROUPED_SERVICES = 'SET_GROUPED_SERVICES';
export const SET_GROUPED_CATEGORIES = 'SET_GROUPED_CATEGORIES';

// INIT ACTIONS
export const SET_INIT_STATE = 'SET_INIT_STATE';
export const SET_FLOW_DATA = 'SET_FLOW_DATA';
export const SET_COMMERCE_ACCOUNT_DATA = 'SET_COMMERCE_ACCOUNT_DATA';
export const SET_INVOICE_FLOW_DATA_SHOWN = 'SET_INVOICE_FLOW_DATA_SHOWN';

// AUTO PROCESS
export const SET_AUTO_PROCESS_DATA = 'SET_AUTO_PROCESS_DATA';

export const SET_SEARCH_DATA = 'SET_SEARCH_DATA';

export const SET_NAVIGATION_DATA = 'SET_NAVIGATION_DATA';

export const SET_GLOBAL_ERROR = 'SET_GLOBAL_ERROR';
export const DISABLE_METHOD = 'DISABLE_METHOD';
export const SET_DISABLED_METHOD = 'SET_DISABLED_METHOD';
export const SET_DISABLED_SERVICE = 'SET_DISABLED_SERVICE';
